import ApiConfig from '../app_config/apiConfig';
import UtilityService from './utilityService';
import { Store } from '../store/store';
import authorize from './authorize';

class HttpAPI {
  constructor() {
    this.baseUrl = ApiConfig.baseUrl[process.env.REACT_APP_ENVIRONMENT_NAME] ? ApiConfig.baseUrl[process.env.REACT_APP_ENVIRONMENT_NAME] : ApiConfig.baseUrl.prod;
  }



  // // =====================
  // // Function to prepare http requests list
  // // return async function
  // // =====================
  requestApi = async (config, hideLoader, cancelAuthCheck, loopCounter) => {
    let loopCounterVal = 1; 
    if(loopCounter !== undefined && loopCounter !== null)
        loopCounterVal = loopCounter;
    if(loopCounterVal <= 5) {
      let apiUrl; let requestBody;
      let httpRequest = [];
      const reqHeaders = new window.Headers(ApiConfig.header);
      if(!cancelAuthCheck){
        await this.authenticationCheck();
      }

      config.forEach(apiData => {
        if (apiData.api.header && Object.keys(apiData.api.header).length > 0) {

          Object.keys(apiData.api.header).forEach((headerKey) => {
            reqHeaders.set(headerKey, apiData.api.header[headerKey]);
          });
        }
        const authData = Store.getState().authenticationData?Store.getState().authenticationData.userDetails:{};
        const {spoToken,accountId} = authData;
        const requestAccessToken = apiData.api.tokenId? authData[`${apiData.api.tokenId}`]: authData.accessToken;    
        reqHeaders.set('Authorization', `Bearer ${requestAccessToken}`);
        reqHeaders.set('Strict-Transport-Security', 'max-age=31536000; includeSubDomains');
        if(spoToken)
        {
          reqHeaders.set('SPOAuthorization', spoToken)
        }
        if(accountId)
        {
          reqHeaders.set('AccountId', accountId)
        }
        const apiBaseUrl = apiData.api.baseUrl?apiData.api.baseUrl:this.baseUrl;
        apiUrl = apiData.api.endpoint ? apiBaseUrl + apiData.api.endpoint : apiBaseUrl;
        requestBody = apiData.api.data ? JSON.stringify(apiData.api.data) : null;
        httpRequest = [...httpRequest, new window.Request(apiUrl, {
          method: apiData.api.method,
          body: requestBody,
          headers: reqHeaders
        })]
      });
      return this.executeFetch(httpRequest, hideLoader, config, loopCounterVal);
    }
    // eslint-disable-next-line no-else-return
    else {
      throw new Error("Maximum API request completed");
    }
  }




  // // =====================
  // // Function to execute http requests
  // // return async function
  // // =====================
  executeFetch = (request, hideLoader, config, loopCounter) => {
    let data;
    const loopCounterVal = loopCounter + 1;
    if (!hideLoader) {
      UtilityService.manageLoader(true);
    }

    let promises = [];
    data = [];
    request.forEach(element => {
      promises = [...promises, window.fetch(element).then(
        (res) => {
          if (!res.ok) {
            return res;
          }
          if (res.headers.get('Content-Type') === "image/jpeg" || res.headers.get('Content-Type') === "text/plain") {
            return res.body;
          }
          return res.json();
        }

      )]
    });
    data = Promise.all(
      promises).then(async (resData) => {
        let responseData = resData;
        if (resData && resData[0] && (resData[0].status === 401 || resData[0].status === 403)) {
          await this.authenticationCheck(true)
          .then(async ()=>{
            await this.requestApi(config, hideLoader, true, loopCounterVal)
            .then((recallData)=>{
              responseData = recallData;
            },(error)=>{ 
              throw new Error(error);
            });
          })          
        }
        return responseData;
      }).catch(async (error) => {
        let responseData = error;
        UtilityService.manageLoader(false);
        if (error && (error.status === 401 || error.status === 403)) {
          await this.authenticationCheck(true)
          .then(async ()=>{
            await this.requestApi(config, hideLoader, true, loopCounterVal)
            .then((recallData)=>{
              responseData = recallData;
            });
          }) 
        }
        else{
          throw new Error(error);
        }
        return responseData;
      });
    return data;
  }




  // // =====================
  // // Function to validate the token expiry
  // // redirect if token expired
  // // =====================
  authenticationCheck = async (proceedAuthentication) => {
    if (proceedAuthentication || UtilityService.checkTokenExpiry()) {
      localStorage.clear();
      window.sessionStorage.removeItem('cartCompareData');
      await authorize.getTokenAcquireAsync();
    }
  }



}

const HttpService = new HttpAPI();
Object.freeze(HttpService);

export default HttpService;